import { useAuthContext } from '@contexts/auth';
import type { FormErrors } from '@customTypes/errors';
import api from '@services/api';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';

const useForm = () => {
  const { refreshPermissions } = useAuthContext();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<FormErrors | null>(null);
  
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const data = Object.fromEntries(formData.entries());

    setLoading(true);
    setErrors(null);

    try {
      const response = await api.post('/account/login', {
        email: data.email,
        password: data.password,
      });

      if (response.data.access_token) {
        const { access_token, expiration, name, email, id } = response.data;

        if (window?.clarity) {
          window.clarity('identify', email, '', '', name);
        }

        const user = {
          id,
          name,
          email,
        };

        datadogRum.setUser(user);

        Cookies.set('accessToken', access_token, {
          expires: new Date(expiration),
          path: '/',
        });

        await refreshPermissions();

        navigate('/painel', { replace: true });
      } else if (response.data.errors) {
        setErrors(response.data.errors);
      }
    } catch (error) {
      toast.error('Erro ao fazer login. Verifique suas credenciais e tente novamente.');
      datadogRum.addError(new Error('Fail to login'), {
        error,
        email: data.email,
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    onSubmit,
    loading,
    errors,
  };
};

export default useForm;
